<template>
   <div style="background-color: #FAFBFC; padding-bottom: 32px">
      <div style="display: block; height: 300px">
         <v-particles :max-particles="50" :id="name" :color="['#a34242', '#2C405A', '#FAFBFC']" :speed="0.4">
            <div slot="header">
               <h3 class="subtitle"> v1.2.9</h3>
            </div>
            <div slot="content" style="padding: 0">
               <el-row type="flex" justify="center">
                  <h1 style="font-size: 42px; font-weight: 600; display: flex" class="title">vParticles</h1>
               </el-row>
            </div>
         </v-particles>
      </div>
      <el-row type="flex" justify="center" style="margin-top: -50px" :gutter="20">
         <el-col :xs="24" :sm="24" :md="18" :lg="16" :xl="10">
            <el-card>
               <h3 style="margin: 0; width: 100px" class="subtitle2">Installation</h3>
               <p style="margin-bottom: 7px">Npm installation:</p>
               <editor-component
                  title="~terminal"
                  :lines="['npm i @agustinm/v-particles -S']"
               />
            </el-card>
            <el-card style="margin-top: 16px">
               <h3 style="margin: 0; width: 53px" class="subtitle2">Usage</h3>
               <p style="margin-bottom: 7px">Plugin declaration:</p>
               <editor-component
                  title="~/src/main.js"
                  :lines="[
                     'import Vue from \'vue\';',
                     'import vParticles from \'@agustinm/v-particles\';',
                     'Vue.use(vParticles);'
                     ]"
               />
            </el-card>
            <el-card style="margin-top: 16px">
               <h3 style="margin: 0; width: 80px" class="subtitle2">Examples</h3>
               <p style="margin-bottom: 7px">Basic usage with default options:</p>
               <editor-component style="margin-top: 7px" title="~/src/main.js"
                                 :lines="['<v-particles></v-particles>']"/>
               <p style="margin-bottom: 7px">With custom colors:</p>
               <editor-component title="~/src/main.js" :lines="[
                  '<v-particles color=\'#ffffff\'></v-particles>',
                  '<v-particles :color=\'[\'#2C405A\', \'#FAFBFC\']\'></v-particles>'
               ]"/>
               <p style="margin-bottom: 7px">Multiple instances</p>
               <editor-component style="margin-top: 7px" title="~/src/main.js"
                                 :lines="['<v-particles id=\'first-one\'></v-particles>',
                                 '<v-particles id=\'second-one\'></v-particles>']"/>
               <p style="margin-bottom: 7px">Every option can be applied the same way.</p>
            </el-card>
            <el-card style="margin-top: 16px">
               <h3 style="margin: 0; width: 70px" class="subtitle2">Options</h3>
               <p style="margin-bottom: 7px">Customization options for v-particles</p>
               <table class="el-table">
                  <thead>
                  <tr style="font-size: 16px; color: #2C405A">
                     <td>Option name</td>
                     <td>Type</td>
                     <td>Default</td>
                     <td>Description</td>
                  </tr>
                  </thead>
                  <tbody class="el-table__body" style="font-size: 16px; color: black">
                  <tr class="el-table-">
                     <td><strong>background</strong></td>
                     <td>String</td>
                     <td>#FAFBFC</td>
                     <td>Background color for particles container</td>
                  </tr>
                  <tr>
                     <td><strong>color</strong></td>
                     <td>String/Array</td>
                     <td>#a34242</td>
                     <td>Color, or colors for the particles</td>
                  </tr>
                  <tr>
                     <td><strong>connectParticles</strong></td>
                     <td>Boolean</td>
                     <td>true</td>
                     <td>Whether the particles should be connected or not</td>
                  </tr>
                  <tr>
                     <td><strong>height</strong></td>
                     <td>String</td>
                     <td>inherit</td>
                     <td>Height of the particles container</td>
                  </tr>
                  <tr>
                     <td><strong>id</strong></td>
                     <td>String</td>
                     <td></td>
                     <td>Unique identifier for the component instance</td>
                  </tr>
                  <tr>
                     <td><strong>maxParticles</strong></td>
                     <td>Number</td>
                     <td>127</td>
                     <td>Number of particles to display</td>
                  </tr>
                  <tr>
                     <td><strong>minDistance</strong></td>
                     <td>Number</td>
                     <td>93</td>
                     <td>Minimum distance between particles</td>
                  </tr>
                  <tr>
                     <td><strong>responsive</strong></td>
                     <td>Array</td>
                     <td>(See below)</td>
                     <td>Array with responsive configuration</td>
                  </tr>
                  <tr>
                     <td><strong>speed</strong></td>
                     <td>Number</td>
                     <td>0.5</td>
                     <td>Number specifying particles speed(1 = 100%, 1.1 = 110%, ...).</td>
                  </tr>
                  <tr>
                     <td><strong>sizeVariations</strong></td>
                     <td>Number</td>
                     <td>4</td>
                     <td>Amount of different particles sizes</td>
                  </tr>
                  <tr>
                     <td><strong>scaleWidth</strong></td>
                     <td>Number</td>
                     <td>1</td>
                     <td>Width scale of the container</td>
                  </tr>
                  <tr>
                     <td><strong>scaleHeight</strong></td>
                     <td>Number</td>
                     <td>1</td>
                     <td>Height scale of the container</td>
                  </tr>
                  </tbody>
               </table>
            </el-card>
            <el-card style="margin-top: 16px">
               <h3 style="margin: 0; width: 97px" class="subtitle2">Responsive</h3>
               <p style="margin-bottom: 7px">With vParticles you can configure how the plugin will look based on the
                  screen size:</p>
               <div class="editor">
                  <div class="editor__toolbar">
                     <div class="button"></div>
                     <div class="button"></div>
                     <div class="button" style="margin-right: 7px"></div>
                     ~your-component.vue
                  </div>
                  <div class="editor__content" style="padding-top: 5px; padding-bottom: 5px">
                     <div class="editor__line line">
                        <span class="line__number">8</span> &nbsp;&nbsp;responsive: [
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">9</span> &nbsp;&nbsp;&nbsp;&nbsp;{
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">10</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;breakpoint:&nbsp;<span
                        class="editor__value">768</span>,
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">11</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;options: {
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">12</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;maxParticles:&nbsp;<span
                        class="editor__value">200</span>,
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">13</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;color:&nbsp;<span
                        class="editor__value">'#48F2E3'</span>,
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">14</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;connectParticles:&nbsp;<span
                        class="editor__value">false</span>
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">15</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">16</span> &nbsp;&nbsp;&nbsp;&nbsp;}, {
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">17</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;breakpoint:&nbsp;<span
                        class="editor__value">425</span>,
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">18</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;options: {
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">19</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;maxParticles:&nbsp;<span
                        class="editor__value">100</span>,
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">20</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;connectParticles:&nbsp;<span
                        class="editor__value">true</span>
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">21</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">22</span> &nbsp;&nbsp;&nbsp;&nbsp;}, {
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">23</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;breakpoint:&nbsp;<span
                        class="editor__value">320</span>,
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">24</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;options: {
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">25</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;maxParticles:&nbsp;<span
                        class="editor__value">0</span>&nbsp;<span
                        class="editor__comment">// disables particles.js</span>
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">26</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">27</span> &nbsp;&nbsp;&nbsp;&nbsp;}
                     </div>
                     <div class="editor__line line">
                        <span class="line__number">28</span> &nbsp;&nbsp;]
                     </div>
                  </div>
               </div>
               <p style="margin-bottom: 7px">The "responsive" prop consists of an object array specifying a
                  breakpoint for each object, and an "options" object where you can set options specifically for each
                  screen size.</p>
            </el-card>
         </el-col>
      </el-row>
   </div>
</template>

<script>
   export default {
      data() {
         return {
            name: 'info'
         }
      }
   };
</script>
<style scoped>
   .title {
      background-color: #a34242;
      color: white;
      padding-left: 10px;
      padding-right: 10px;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-select: none;
   }

   .subtitle {
      background-color: #2C405A;
      color: white;
      padding-left: 33px;
      padding-right: 10px;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-select: none;
   }

   .subtitle2 {
      background-color: #a34242;
      color: white;
      font-weight: 600;
      padding-left: 33px;
      padding-right: 10px;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-select: none;
   }

   html, body, h1, h2, h3, h4, h5, h6, p, button, input, label, li, th, td, tr, table, ul, span, thead, tbody {
      font-family: 'Titillium Web', sans-serif;
   }
</style>



// WEBPACK FOOTER //
// src/components/Info.vue